import { Loading, NavigateButton, Table, Text } from '@/components';
import {
  TABLE_BUTTON_WIDTH,
  TABLE_DATETIME_WIDTH,
  datetimeFormat,
} from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { useRoles } from '../../hooks';

export const RolesPage: FC = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageNumber = Number(searchParams.get('page') ?? 1);
  const roles = useRoles();

  if (roles.isLoading || !roles.data) {
    return <Loading />;
  }

  return (
    <Table
      rowKey="id"
      dataSource={roles.data}
      columns={[
        {
          title: t('name'),
          dataIndex: 'name',
          render: (value) => <Text weight="regular" text={value} />,
        },
        {
          title: t('created-datetime'),
          dataIndex: 'createdAt',
          width: TABLE_DATETIME_WIDTH,
          render: (datetime) => (
            <Text weight="regular" text={datetimeFormat({ datetime })} />
          ),
        },
        {
          title: t('updated-datetime'),
          key: 'updatedAt',
          dataIndex: 'updatedAt',
          width: TABLE_DATETIME_WIDTH,
          render: (datetime) => (
            <Text weight="regular" text={datetimeFormat({ datetime })} />
          ),
        },
        {
          title: '',
          key: 'actions',
          width: TABLE_BUTTON_WIDTH,
          render: (_, record) => (
            <NavigateButton
              type="default"
              path={`roles/${record.id}`}
              text={t('details')}
              asLink
            />
          ),
        },
      ]}
      pagination={{
        pageSize: 10,
        position: ['bottomRight'],
        showSizeChanger: false,
        total: roles.data.length,
        current: pageNumber > 0 ? pageNumber : 1,
        onChange: (newPageNumber) => {
          searchParams.set('page', newPageNumber.toString());
          setSearchParams(searchParams);
        },
      }}
    />
  );
};
